import {httpGet} from "../libs/http";

export const adminLoadLogs = (page, per_page, onSuccess = null, onFailure = null) => dispatch => {
    httpGet('/admin/system/logs/?page=' + page + '&per_page=' + per_page, (res) => onSuccess(res), (err) => onFailure(err));
};
